{
  "slug": "iq-vs-emotional-intelligence",
  "title": "IQ vs Emotional Intelligence",
  "description": "IQ samples cognitive ability; emotional measures address recognizing, understanding, and regulating emotion.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "Purpose",
      "paragraphs": [
        "IQ samples cognitive ability; emotional measures address recognizing, understanding, and regulating emotion.",
        "Begin with purpose rather than asking which score is universally better."
      ]
    },
    {
      "heading": "Measurement differences",
      "paragraphs": [
        "Compare content, limits, norms, reliability, validity, preparation, and decision rules.",
        "Correlation does not make measures interchangeable."
      ]
    },
    {
      "heading": "What to use",
      "paragraphs": [
        "Use evidence validated for the question. Admissions, clinical evaluation, grades, creativity, and emotion need different evidence.",
        "Do not convert scores without a justified publisher method."
      ]
    }
  ],
  "related": ["iq-vs-intelligence", "iq-vs-eq", "how-is-iq-measured"],
  "sources": [],
  "faqs": [],
  "summary": "IQ samples cognitive ability; emotional measures address recognizing, understanding, and regulating emotion. Content reviewed 18 July 2026."
}
